import React from 'react';
import ReactDOM from 'react-dom';

import ProductBuyButton from '../wc-checkout/productBuyButton/ProductBuyButton.jsx';

function initBuyButton() {
  const productBuyButtonContainer = document.getElementById("price-button-holder");
  
  productBuyButtonContainer && ReactDOM.render(React.createElement(ProductBuyButton, {props: productButtonProps}), productBuyButtonContainer);
}

document.addEventListener('DOMContentLoaded', () => {
  initBuyButton();
});